import { render } from "./SavedModal.vue?vue&type=template&id=56670d80&scoped=true"
import script from "./SavedModal.vue?vue&type=script&lang=js"
export * from "./SavedModal.vue?vue&type=script&lang=js"

import "./SavedModal.vue?vue&type=style&index=0&id=56670d80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56670d80"]])

export default __exports__